import { SelectProps } from 'antd';
import { FormProps } from 'antd/lib';
import { useMemo } from 'react';
import { useOutletContext } from 'react-router';

import useFormInitialSet from '@/hooks/useFormInitialSet';
import { useSelectPropsWithInitial } from '@/hooks/useSelectWithInitialValue';

export const useShippingLabelsFilter = (formProps: FormProps, filters: any[]) => {
  const { form } = formProps;
  const initialValues: Record<string, any> = useMemo(
    () =>
      Object.fromEntries(
        filters.map(filter => {
          const valueParsed = parseInt(filter.value, 10);
          const value = isNaN(valueParsed) ? filter.value : valueParsed;

          return [filter.field, value];
        }),
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  useFormInitialSet(form, initialValues, [
    {
      watchField: 'company',
      resetFields: ['company_type'],
    },
  ]);

  const { companySelectProps } = useOutletContext<{
    companySelectProps: SelectProps;
  }>();
  const companySelectPropsWithInitials = useSelectPropsWithInitial({
    selectProps: companySelectProps,
    resource: 'empresas',
    initialValue: initialValues.company,
    labelKey: 'full_name',
    valueKey: 'id',
  });

  return {
    companySelectProps: companySelectPropsWithInitials,
  };
};
